import styled from "styled-components";
import {
  ContentBodyWrapper,
  ContentHeaderWrapper,
  ContentWrapper,
  PopupContainer,
} from "../../../styles/popup";

export const CurrentReservationPopupContainer = styled(PopupContainer)``;
export const CurrentReservationPopupContentWrapper = styled(ContentWrapper)`
  width: 1346px;
  height: 860px;
`;
export const CurrentReservationPopupContentHeaderWrapper = styled(
  ContentHeaderWrapper,
)``;
export const CurrentReservationPopupContentBodyWrapper = styled(
  ContentBodyWrapper,
)`
  gap: 80px;
  margin-bottom: 33.72px;
`;

export const Title = styled.div`
  font-family: Pretendard;
  font-size: 20.23px;
  font-weight: 600;
  line-height: 24.15px;
  text-align: left;

  margin-bottom: 20px;
  text-align: left;
`;

export const ImageWrapper = styled.img`
  width: 536px;
  height: 716px;
  top: 192px;
  left: 390px;
  gap: 0px;
  border-radius: 15px;
  border: 5px dashed #bebebe;
  box-sizing: border-box;
  opacity: 0.8px;
`;
export const ImageDropInitialContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p {
    margin: 0px;
  }
`;

export const DataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 701px;
  height: 632px;
  gap: 20px;
`;

export const InputDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const DataRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const CurrentReservationActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const Label = styled.label`
  font-family: Pretendard;
  font-size: 20.23px;
  font-weight: 600;
  line-height: 24.15px;
  text-align: left;

  flex: 1;
`;

export const Value = styled.label`
  display: flex;
  padding: 8px;
  align-items: center;
  font-family: Pretendard;
  font-size: 10.79px;
  font-weight: 500;
  line-height: 12.88px;
  text-align: left;
  border: 0.67px solid var(--Black-200, rgba(183, 183, 183, 1));
  flex: 3;
`;

export const TournamentListWrapper = styled.div`
  background-color: white;
  width: 662px;
  padding: 40px;
  display: flex;
  flex-direction: column;
`;

export const SearchInput = styled.input`
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-right: 10px;
`;

export const ResContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 650px;
  height: 676px;
  padding: 26px 30px;
  box-sizing: border-box;
  border-radius: 4.59px;
  background: #f0f0f0;
`;

export const HeaderActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 23px;

  > .searchBox {
    display: flex;
    align-items: center;
    width: 308px;
    height: 35px;
    border-radius: 15px;
    background-color: #fff;
    padding: 0 15px;
    box-sizing: border-box;

    > input {
      flex: 1;
      border: none;
      outline: none;
      color: #121212;
      font-family: Pretendard;
      font-size: 12px;
      font-weight: 600;
    }

    input::placeholder {
      color: #b7b7b7;
    }

    .searchIcon {
      width: 20px;
      height: 30px;
      cursor: pointer;
      text-align: right;
      line-height: 40px;

      > img {
        width: 100%;
      }
    }
  }
`;

export const MemberTableWrapper = styled.div``;

export const TableHeader = styled.div`
  display: flex;
  padding: 4.59px 15px 4.59px 15px;
  margin-bottom: 10px;
`;

export const TableContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const TableContent = styled.div`
  display: flex;
  height: 40px;
  padding: 4.59px 15px 4.59px 15px;
  border-radius: 11.47px;
  background: #fff;
  box-sizing: border-box;
  align-items: center;
`;

export const HeaderItem = styled.div<{ weight: any }>`
  flex: ${({ weight }) => weight};
  text-align: center;
  font-family: Pretendard;
  font-size: 11.47px;
  font-weight: 500;
`;

export const ColumnItem = styled.div<{ weight: any }>`
  flex: ${({ weight }) => weight};
  text-align: center;
  font-family: Pretendard;
  font-size: 11.47px;
  font-weight: 500;

  &.i1 > span {
    padding: 5px 30px;
    height: 22.93px;
    border-radius: 5.73px;
    background: #373636;
    color: #fff;
    line-height: 22.93px;
  }
`;
